import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import dayjs from 'dayjs';
import TransactionLink from "../../../TransactionLink";
import React from "react";
import NumberCell from "../../../Table/Cell/Number";
import LocationTag from "../../../LocationTag";
import FormatNumber from "../../../FormatNumber";
import {LockIcon} from "../../../Access/common/LockIcon";
import DescriptionCell from "../../../Table/Cell/Description";
import TransactionType from "../../../TransactionType";
import ContactName from "bukku/components/Columns/Reports/Common/ContactName";

function renderQuantity(quantity) {
    return (
        <div className="BaseTable__row-cell-text">
            <FormatNumber amount={quantity} dp2={4} />
        </div>
    );
}

function renderAmount(
    amount, currencySymbol, hideInventoryCosting) {
    if (hideInventoryCosting) {
        return (
            <LockIcon className="grey" />
        );
    }

    if (amount === '' || amount === undefined || amount === null)
        return null;

    return (
        <div className="amount-container">
            <div className="currency">{currencySymbol}</div>
            <div className="value" style={{width: 120}}>
                <FormatNumber amount={amount} dp2={4} />
            </div>
        </div>
    );
}

function getColumns(props) {
    const { locations, reportData, hideInventoryCosting } = props;

    const currencySymbol = reportData?.company?.currency_symbol;

    return [ // Total 200
        {
            key: 'date',
            dataIndex: 'date',
            title: t`Date`,
            width: 0,
            flexGrow: 17,
            cellRenderer: ({ rowData }) => {
                const label = dayjs(rowData.date).format('DD/MM/YYYY');
                return (
                    <div className="indent-col BaseTable__row-cell-text">
                        <TransactionLink transaction={rowData} label={label} />
                    </div>
                );
            },
        },
        {
            key: 'number',
            dataIndex: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 19,
            cellRenderer: ({ rowData }) => (
                <div className="BaseTable__row-cell-text">
                    <NumberCell text={rowData.number} />
                </div>
            ),
        },
        {
            key: 'type',
            dataIndex: 'type',
            title: t`Type`,
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => (
                <div className="BaseTable__row-cell-text">
                    <TransactionType record={rowData} />
                </div>
            ),
        },
        {
            key: 'number2',
            dataKey: 'number2',
            title: t`Reference No.`,
            width: 0,
            flexGrow: 20,
            cellRenderer: ({rowData}) => (
                <div className="BaseTable__row-cell-text">
                    <DescriptionCell text={rowData.number2} />
                </div>
            ),
        },
        {
            key: 'contact_name',
            dataIndex: 'contact_name',
            title: t`Contact`,
            width: 0,
            flexGrow: 20,
            cellRenderer: ({rowData}) => (
                <div className="BaseTable__row-cell-text">
                    {rowData.contact_id ?
                        <ContactName
                            contact_id={rowData.contact_id}
                            contact_name={rowData.contact_name || '-'}
                            contact_code={rowData.contact_code || ''}
                        /> :
                        <DescriptionCell text={rowData.description} />}
                </div>
            ),
        },
        {
            key: 'contact_code',
            dataIndex: 'contact_code',
            title: t`Contact Code`,
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData: record }) => record.contact_code,
        },
        {
            key: 'description',
            dataIndex: 'description',
            title: t`Description`,
            width: 0,
            flexGrow: 24,
            cellRenderer: ({rowData}) => (
                <div className="BaseTable__row-cell-text">
                    <DescriptionCell text={rowData.description} />
                </div>
            ),
        },
        {
            key: 'location_code',
            dataIndex: 'location_code',
            title: t`Location`,
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData }) => {
                const location = rowData.location_code ?
                    locations.find(item => item.code === rowData.location_code) :
                    undefined;
                return (
                    <div className="BaseTable__row-cell-text">
                        {location ? <LocationTag location={location} /> : null}
                    </div>
                );
            },
        },
        {
            key: 'unit_cost',
            dataIndex: 'unit_cost',
            title: `${t`Unit Cost`} *`,
            align: 'right',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderAmount(
                rowData.unit_cost, currencySymbol, hideInventoryCosting,
            ),
        },
        {
            key: 'quantity',
            dataIndex: 'quantity',
            title: t`Qty Move`,
            align: 'right',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderQuantity(rowData.quantity),
        },
        {
            key: 'amount',
            dataIndex: 'amount',
            title: t`Value Move`,
            align: 'right',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderAmount(
                rowData.amount, currencySymbol, hideInventoryCosting,
            ),
        },
        {
            key: 'quantity_balance',
            dataIndex: 'quantity_balance',
            title: t`Qty Balance`,
            align: 'right',
            width: 0,
            flexGrow: 22,
            cellRenderer: ({ rowData }) => renderQuantity(rowData.quantity_balance),
        },
        {
            key: 'amount_balance',
            dataIndex: 'amount_balance',
            title: t`Value Balance`,
            align: 'right',
            width: 0,
            flexGrow: 22,
            cellRenderer: ({ rowData }) => renderAmount(
                rowData.amount_balance, currencySymbol, hideInventoryCosting,
            ),
        },
    ];
}

export default {
    storageKey: StorageKey.report_inventory_detail,
    getReportLabel: () => t`Inventory Detail`,
    required: [
        'date',
        'number',
        'quantity',
        'amount',
    ],
    defaulto: [
        'type',
        'unit_cost',
        'quantity_balance',
        'amount_balance',
    ],
    getColumns,
};
